module.exports = __webpack_public_path__ + "static/phone-slide-5-a713169296390b54103fb4c98b887bf3.png";